import { useEffect, useState } from 'react';
import { listarAtivosPorTituloOcorrencia } from '~/Services/Service';

// W-0489 / T13 — Hook de fetch de ativos para um titulo (Tab Por Titulo, nivel 2).
// LICOES Ciclo 9 L3: pattern `let ativo = true`.

const extrairMsg = (err, fallback) =>
  (err && err.message) ? err.message : fallback;

const useAtivosPorTitulo = (titulo, dataInicio) => {
  const [estado, setEstado] = useState({
    loading: false,
    items: [],
    erro: null,
  });

  useEffect(() => {
    if (titulo == null) {
      setEstado({ loading: false, items: [], erro: null });
      return undefined;
    }
    let ativo = true;
    setEstado((prev) => ({ ...prev, loading: true, erro: null }));
    listarAtivosPorTituloOcorrencia(titulo, dataInicio)
      .then((res) => {
        if (!ativo) return;
        setEstado({ loading: false, items: Array.isArray(res) ? res : [], erro: null });
      })
      .catch((err) => {
        if (!ativo) return;
        setEstado({
          loading: false,
          items: [],
          erro: extrairMsg(err, 'Erro ao carregar ativos.'),
        });
      });
    return () => {
      ativo = false;
    };
  }, [titulo, dataInicio]);

  return estado;
};

export default useAtivosPorTitulo;
